@if (templateForPermitForm) {
  <div class="numeric-data-style">
    <wm-common-text
    class="label"
    [data]="{text: entity.label}"
    ></wm-common-text>

  <div
    [ngClass]="
      numericDE.type === NumericDataType.Currency ? 'input-group mb-3' : ''
    "
  >
    <div
      *ngIf="numericDE.type === NumericDataType.Currency"
      class="currency-field"
    >
      <span class="currency-symbol">$</span>
        <wm-common-text
          [data]="{text: entity.value || ''}"
        ></wm-common-text>

      <!-- <div class="text">
      <wm-common-text
        [data]="{text: '$ '+(entity.value || '')}"
      ></wm-common-text> -->
    </div>
  </div>

  <div *ngIf="numericDE.type != NumericDataType.Currency">
    <wm-common-text
      class="text"
      [data]="{text: entity.value}"
    ></wm-common-text>
  </div>
</div>
  <!-- </div> -->
}@else{
  <div class="form-group">
    <wm-de-label
      [entity]="entity"
      [for]="entity.templateCode"
      [displayOnly]="true"
      *ngIf="showLabel"
    ></wm-de-label>

    <div
      [ngClass]="
        numericDE.type === NumericDataType.Currency ? 'input-group mb-3' : ''
      "
    >
      <div
      >
        <span class="currency-symbol"
          *ngIf="numericDE.type === NumericDataType.Currency"
          class="currency-field">$</span>

        <span>{{entity.value}}</span>
      </div>
    </div>
  </div>
}
